export const themeSpacing = [0, 4, 8, 16, 20, 24, 32, 40, 48];
